import { Remarkable } from 'remarkable';

const md = new Remarkable();

md.set({
  html: true,
  breaks: true,
});

export default function Parser(mdText) {
  const transformedHTML = md.render(mdText);
  // transformedHTML = transformedHTML.replace(/<h1>/,'<h1 style={{color: theme.content.text}}>');
  // let transformedText=transformedHTML.replace('<p>','<div>').replace('</p>','</div>');
  return transformedHTML;
}
